<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import {
  getAdminJimengSettings,
  saveAdminJimengSettings,
  type AdminJimengSettings
} from "../admin-api";

const loading = ref(false);
const saving = ref(false);
const secretPreview = ref("");
const form = reactive({
  accessKeyId: "",
  secretAccessKey: ""
});

onMounted(loadSettings);

async function loadSettings() {
  loading.value = true;
  try {
    applySettings(await getAdminJimengSettings());
  } catch (currentError) {
    message.error(currentError instanceof Error ? currentError.message : "即梦 API 配置加载失败。");
  } finally {
    loading.value = false;
  }
}

async function submitSettings() {
  saving.value = true;
  try {
    const response = await saveAdminJimengSettings({
      accessKeyId: form.accessKeyId,
      secretAccessKey: form.secretAccessKey || undefined
    });
    message.success(response.message);
    form.secretAccessKey = "";
    await loadSettings();
  } catch (currentError) {
    message.error(currentError instanceof Error ? currentError.message : "即梦 API 配置保存失败。");
  } finally {
    saving.value = false;
  }
}

function applySettings(settings: AdminJimengSettings) {
  form.accessKeyId = settings.accessKeyId ?? "";
  form.secretAccessKey = "";
  secretPreview.value = settings.secretAccessKey?.hasValue ? settings.secretAccessKey.preview : "未配置";
}
</script>

<template>
  <a-card class="admin-settings-card" :loading="loading">
    <template #title>即梦 API 配置</template>
    <template #extra>
      <a-tag :color="secretPreview === '未配置' ? 'red' : 'green'">
        {{ secretPreview === "未配置" ? "未配置" : "已配置" }}
      </a-tag>
    </template>

    <a-alert
      class="admin-form-alert"
      type="info"
      show-icon
      message="只维护火山引擎 AccessKey / Secret，其余接口地址、模型、尺寸和上传策略由后端统一管理。"
    />

    <a-form layout="vertical" :model="form" @finish="submitSettings">
      <a-row :gutter="16">
        <a-col :xs="24" :md="12">
          <a-form-item label="Access Key ID">
            <a-input v-model:value="form.accessKeyId" placeholder="AKLT..." />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="12">
          <a-form-item label="Secret Access Key">
            <a-input-password v-model:value="form.secretAccessKey" :placeholder="`留空不修改，当前：${secretPreview}`" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-button type="primary" html-type="submit" :loading="saving">保存即梦 API 配置</a-button>
    </a-form>
  </a-card>
</template>
